import React from 'react';
const Example = (props) => (<div className="blog-thumbnail">
        <a href="#" className="blog-thumbnail__link" target="_blank">
            <picture>
                <source media="(min-width: 768px)" srcSet="https://dummyimage.com/700x700/9fa4a8/fff.png, https://dummyimage.com/1400x1400/9fa4a8/fff.png 2x"/>
                <img src="https://dummyimage.com/373x373/9fa4a8/fff.png" className="blog-thumbnail__image" alt="Být lepší a umět něco pro budoucnost. Nejčastější důvody, proč se lidé vzdělávají" srcSet="https://dummyimage.com/373x373/9fa4a8/fff.png, https://dummyimage.com/746x746/9fa4a8/fff.png 2x"/>
            </picture>
            <div className="blog-thumbnail__content">
                <h3 className="blog-thumbnail__title">
                    Být lepší a umět něcopro budoucnost. Nejčastější důvody, proč se lidé vzdělávají.
                </h3>
            </div>
        </a>
    </div>);
export default Example;
